// extracted by mini-css-extract-plugin
export default {"container":"Tints_container__ts3N6","wrap":"Tints_wrap__d+K0s","tint":"Tints_tint__exYQz","color":"Tints_color__HnK-+","label":"Tints_label__70OgI"};